import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-geolocalisation-ps',
    templateUrl: './geolocalisation-ps.component.html',
    styleUrls: ['./geolocalisation-ps.component.scss']
})
export class GeolocalisationPsComponent   {

  constructor() { }

}
